module.exports = __webpack_public_path__ + "img/icon-account-logout-green@3x.31703c50.png";